import React, {
  useState,
  useCallback,
  useEffect,
  use,
  useRef,
  useLayoutEffect,
} from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import {
  subscribeTopic,
  getSubChannelTopic,
  MessageContentType,
  MessageRepository,
} from "@amityco/ts-sdk";
import { createTextMessage } from "./Amity/AmityProvider.ts";
import StarRating from "./UserPatientScreen/StarRating";
import { formatDistanceToNowStrict } from "date-fns";
import axios from "axios";

const MessagingPage = () => {
  const [list, setList] = useState([]);
  const [chatBoxName, setChatBoxName] = useState("");
  const [subChannelId, setSubChannelId] = useState(null);
  const [creator, setCreator] = useState("");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [query, setQuery] = useState("");
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [previews, setPreviews] = useState({});
  const messageBottomRef = useRef(null);

  const username = localStorage.getItem("username");
  const disposers = [];
  const subscribeSubChannel = (subChannel) => {
    disposers.push(subscribeTopic(getSubChannelTopic(subChannel)));
  };
  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const handleChangeMessage = (e) => {
    setNewMessage(e.target.value);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (!subChannelId) return;
    if (!newMessage) return;

    await createTextMessage(subChannelId, newMessage, username);
    setNewMessage("");
    scrollToTarget();
  };
  const getChannelMessages = useCallback(() => {
    const unsubscribe = MessageRepository.getMessages(
      { subChannelId, limit: 10000 },
      ({ data: messages, onNextPage, hasNextPage, loading, error }) => {
        // Sort the messages based on channelSegment in ascending order (numeric)
        messages.sort((a, b) => a.channelSegment - b.channelSegment);
        setMessages(messages); // Reverse the order of messages
      }
    );
    disposers.push(unsubscribe);
  }, [subChannelId, disposers]);

  const watchLatestMessage = useCallback((subChannelId) => {
    if (!subChannelId) return () => {};

    const unsub = MessageRepository.getMessages(
      { subChannelId, limit: 20, isDeleted: false },
      ({ data }) => {
        if (!data || !data.length) {
          setPreviews((prev) => ({ ...prev, [subChannelId]: undefined }));
          return;
        }

        const latest = data.reduce((a, b) => {
          if (!a) return b;
          const segA = a.channelSegment ?? 0;
          const segB = b.channelSegment ?? 0;
          return segB > segA ? b : a;
        }, null);

        setPreviews((prev) => ({
          ...prev,
          [subChannelId]: {
            text:
              latest?.data?.text ??
              (latest?.dataType === "image" ? "📷 Photo" : "New message"),
            createdAt: latest?.createdAt,
          },
        }));
      }
    );

    return unsub;
  }, []);

  const onClickProvider = (index) => {
    setSelectedProviderIndex(index);
    setSelectedProvider(list[index]);
    console.log(list[index]);
    setSubChannelId(list[index].channel_code);
  };

  const getChatList = async () => {
    try {
      const authToken = localStorage.getItem("token");
      const apiUrl = `${API_IP}/api/amity/channels`;
      const username = localStorage.getItem("username");
      axios
        .get(apiUrl, {
          params: { username: username }, // Use the 'userName' obtained from setUserName
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => {
          // Store the API response in the state variable
          setCreator("A" + response.data.userId);
          setList(response.data.chatList);
          console.log(response.data.chatList);
        })
        .catch((error) => {
          console.error(
            "Error fetching data from the API (getChannels):",
            error
          );
        });
    } catch (error) {
      console.log(error);
    }
  };
  const ChatListItem = ({ index, item, isSelected }) => {
    const scid = item.channel_code;
    const preview = previews[scid];
    return (
      <button
        disabled={isSelected}
        onClick={() => onClickProvider(index)}
        className={`ProviderChatCard${isSelected ? "-selected" : ""}`}
      >
        <div className="ProviderChatHeader">
          <div>
            <img
              src={
                item.provider_img[0] ??
                require("../images/avatar_placeholder_0.png")
              }
              alt="Provider Ava"
              className="ProviderImgChatList"
            />
          </div>
          <div className="ProviderNameChatList">
            <div>{item.provider_array[0]}</div>
            <div className="ProviderTitleChatList">
              {item.provider_title[0] ?? ""}
            </div>
          </div>
        </div>
        <div className="ProviderChatBody">
          <div>{preview?.text ?? "Start a conversation"}</div>
          <div>
            {formatDistanceToNowStrict(new Date(preview?.createdAt ?? 0), {
              addSuffix: true,
            })}
          </div>
        </div>
      </button>
    );
  };

  const MessageBubble = ({ message }) => {
    const messageDate = new Date(message.createdAt);
    const messageDateFormat = messageDate.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return (
      <div
        className={`${
          message.creatorId === creator
            ? "senderBubbleItem"
            : "receiverBubbleItem"
        }`}
      >
        <div
          className={`${
            message.creatorId === creator
              ? "senderBubbleText"
              : "receiverBubbleText"
          }`}
        >
          {message.creatorId !== creator ? (
            <div className="creatorText">{message.metadata?.data?.sender}</div>
          ) : (
            ""
          )}
          <div>{message.data?.text} </div>
          <div className="messageDateText">{messageDateFormat}</div>
        </div>
      </div>
    );
  };

  const scrollToTarget = () => {
    if (messageBottomRef.current) {
      messageBottomRef.current.scrollIntoView({
        behavior: "smooth", // Optional: for smooth scrolling
        block: "start", // Optional: align the top of the element with the top of the scrollable area
      });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getChatList();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const disposers = [];
    list.forEach((item) => {
      const scid = item.channel_code; // you already set subChannelId from this
      const d = watchLatestMessage(scid);
      if (d) disposers.push(d);
    });

    return () => disposers.forEach((fn) => fn && fn());
  }, [list, watchLatestMessage]);

  useEffect(() => {
    if (!subChannelId) return;

    const unsubscribe = MessageRepository.getMessages(
      { subChannelId, limit: 50 }, // <= keep this small; 20–100 is typical
      ({ data, onNextPage, hasNextPage, loading, error }) => {
        // don’t mutate the input array
        const sorted = [...data].sort(
          (a, b) => a.channelSegment - b.channelSegment
        );
        setMessages(sorted);
      }
    );

    return () => unsubscribe?.();
  }, [subChannelId]);
  return (
    <>
      <div className="MessagingPage">
        <header className="titleContainer">
          <h1>Messages</h1>
          <p>Connect with your care providers and manage your appointments.</p>
        </header>
        <div className="messagingContent">
          <div className="chatListContainer">
            <div className="chatListSearchEngine">
              <img
                src={require("../images/search-icon.png")}
                className="search-icon"
              />
              <input
                type="text"
                value={query}
                onChange={handleSearchChange}
                placeholder="Search..."
                className="chatSearchInput"
              />
            </div>
            <div className="chatListBody">
              {list.length !== 0 ? (
                <>
                  {list.map((target, index) => {
                    return (
                      <ChatListItem
                        key={index}
                        index={index}
                        isSelected={selectedProviderIndex === index}
                        item={target}
                      />
                    );
                  })}
                </>
              ) : (
                <>
                  <div className="emptyChatList">
                    <img
                      src={require("../images/no-message-pic.png")}
                      className="emptyChatListPic"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="chatBoxContainer">
            <div className="chatBoxHeader">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <div className="ProviderImgChatBoxContainer">
                    <img
                      src={
                        selectedProvider.provider_img ??
                        require("../images/avatar_placeholder_0.png")
                      }
                      alt="Provider Ava"
                      className="ProviderImgChatBox"
                    />
                  </div>
                  <div className="ProviderNameChatBox">
                    <div>{selectedProvider.provider_array[0]}</div>
                    <div className="ProviderTitleChatBox">
                      {selectedProvider.provider_title[0] ?? ""}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="chatBoxBody" id="chatBox">
              {selectedProvider == null ? (
                <div className="emptyChatBox">
                  <div className="emptyChatBoxText">
                    SELECT A PROVIDER TO START A CHAT
                  </div>
                </div>
              ) : (
                <>
                  {messages.map((m) => (
                    <MessageBubble ke={m.messageId} message={m} />
                  ))}
                  <div ref={messageBottomRef}></div>
                </>
              )}
            </div>
            <form className="chatBoxForm" onClick={(e) => handleSendMessage(e)}>
              <div className="chatBoxFooter">
                <input
                  type="text"
                  value={newMessage}
                  placeholder="Search..."
                  onChange={handleChangeMessage}
                  className="chatBoxInput"
                />
                <button className="chatBoxSendButton">
                  <img
                    src={require("../images/send-icon.png")}
                    alt="SendIcon"
                    className="sendChatIcon"
                  />
                </button>
              </div>
            </form>
          </div>
          <div className="chatDetailContainer">
            <div className="chatDetailImg">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <img
                    src={
                      selectedProvider.provider_img ??
                      require("../images/avatar_placeholder_0.png")
                    }
                    alt="Provider Ava"
                    className="ProviderImgChatDetail"
                  />
                </>
              )}
            </div>
            <div className="chatDetailBody">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <StarRating rating={4} maxStars={5} />
                  <div>Phone Number: {selectedProvider.provider_phone[0]}</div>
                  <div>Email: {selectedProvider.provider_email[0]}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessagingPage;
